import "babel-polyfill"
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let stateNubXz = JSON.parse(sessionStorage.getItem('states'))
if(stateNubXz == null || stateNubXz==undefined|| stateNubXz==''){
  stateNubXz = 0
}
const state = {
  count: stateNubXz
}
const mutations = {
  mutationsAddCount(state, n) {
    return (state.count = n)
  }
}

export default new Vuex.Store({
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js